import { styled } from "@linaria/react"
import { useState } from "react"

import { Dialog } from "@/components/Dialog/Dialog.tsx"
import { DiffComponent } from "@/components/Diff/Diff.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { CodeFileRegular } from "@/icons/Icons.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"


export const ReasoningResult_ScriptDiff = (props: {
  content: UIToolCallObservation.ScriptDiff
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <Dialog
      open={dialogOpen}
      onOpenChange={setDialogOpen}
      title={props.content.message.value}
      trigger={(
        <Row clickable={true} onClick={() => setDialogOpen(true)}>
          <FileIcon />
          {props.content.message.value}
        </Row>
      )}
    >
      <DiffComponent data={props.content.diff} panelWidth={() => "720px"} />
    </Dialog>
  )
}

const Row = styled(Horizontal)<{ clickable?: boolean }>`
  display: inline-flex;

  align-items: center;
  gap: 4px;

  ${textStyles.smallestFontSize};
  ${textStyles.breakWord};

  color: var(--secondary-text-color);

  cursor: ${props => (props.clickable ? "pointer" : "default")};

  &:hover {
    color: ${props => (props.clickable ? "var(--text-color)" : "var(--secondary-text-color)")};
  }

  :last-child {
    flex-shrink: 0;
  }
`

const FileIcon = styled(CodeFileRegular)`
  width: 12px;
  height: 12px;
`
